module.exports = __webpack_public_path__ + "img/buildings.30999f88.png";